
import "./login_page.css";
import NavbarLogin from "../../../components/nav/nav_login";
import NavbarSignUpLogin from "../../../components/nav/nav_login_signup_login";
import AboutContainer from "../../../components/home/about/about";
import { useNavigate, useLocation,useSearchParams  } from "react-router-dom";
import { useState } from "react";
import LoginPageLoginForm from "../form/login_page_login_form";

const LoginPageMain = () => {

  
    return (
    <div className="loginpage-whole-outer">
                    <div className="login-left-column">
                        <NavbarLogin/>
                        <div className="login-form-container">
                            <LoginPageLoginForm/>
                        </div>
                    </div>
                    <div className="login-right-column">
                        <NavbarSignUpLogin/>
                    </div>
      </div>
    );
  };
  
  export default LoginPageMain;